/**
 * 首页 - 模板路由入口
 * 
 * 根据用户选择的模板ID，加载对应版本的首页组件
 * 
 * 使用方式：
 * - 经典橙色模板：/src/templates/classic/home/HomePage.tsx
 * - 深色商务模板：/src/templates/dark/home/HomePage.tsx
 * - 清新绿意模板：/src/templates/green/home/HomePage.tsx
 * - 热情红色模板：/src/templates/red/home/HomePage.tsx
 */

import { useTemplate, SITE_TEMPLATES } from "@/context/TemplateContext";

// ============================================
// 导入各模板组件
// ============================================

import ClassicHomePage from "@/templates/classic/home/HomePage";
import ModernHomePage from "@/templates/modern/home/HomePage";
import DarkHomePage from "@/templates/dark/home/HomePage";
import GreenHomePage from "@/templates/green/home/HomePage";
import RedHomePage from "@/templates/red/home/HomePage";
import TechBlueHomePage from "@/templates/tech-blue/home/HomePage";
import DeepBlueHomePage from "@/templates/deep-blue/home/HomePage";
import TealHomePage from "@/templates/teal/home/HomePage";
import SunsetHomePage from "@/templates/sunset/home/HomePage";
import PurpleHomePage from "@/templates/purple/home/HomePage";
import CrystalHomePage from "@/templates/crystal/home/HomePage";

// ============================================
// 模板映射表
// ============================================

const templateComponents = {
  classic: ClassicHomePage,
  modern: ModernHomePage,
  dark: DarkHomePage,
  green: GreenHomePage,
  red: RedHomePage,
  "tech-blue": TechBlueHomePage,
  "deep-blue": DeepBlueHomePage,
  teal: TealHomePage,
  sunset: SunsetHomePage,
  purple: PurpleHomePage,
  crystal: CrystalHomePage,
};

// ============================================
// 首页组件
// ============================================

export default function Home() {
  const { templateId } = useTemplate();
  
  // 根据模板ID选择对应组件，默认使用经典模板
  const TemplateComponent = templateComponents[templateId as keyof typeof templateComponents] || ClassicHomePage;
  
  return <TemplateComponent />;
}

// ============================================
// 导出模板配置（供装修页面使用）
// ============================================

export { SITE_TEMPLATES };
